import About from 'about/About';
import { POPULAR_BOARDS_BY_NAME } from 'PopularBoards';
import { generateRandomBoardHash } from 'RandomBoardGenerator';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import Support from 'support/Support';

import BuildSteps from 'designer/BuildSteps';
import Designer from 'designer/Designer';
import Settings from 'settings/Settings';
import { settingsAtom } from 'state/recoilState';

function Routing() {
  const settings = useRecoilValue(settingsAtom);

  return (
    <Switch>
      <Route exact path="/about" component={About} />
      <Route exact path="/support-us" component={Support} />
      <Route exact path="/settings" component={Settings} />

      <Route path="/designer/random">
        <Redirect
          to={`/designer/hash/${generateRandomBoardHash(settings)}${
            window.location.search
          }`}
        />
      </Route>

      <Route exact path="/designer/id/:boardID" component={Designer} />
      <Route exact path="/designer/hash/:boardHash" component={Designer} />
      <Route path="/designer">
        <Redirect
          to={`/designer/id/${POPULAR_BOARDS_BY_NAME.checkerboard.id}${window.location.search}`}
        />
      </Route>

      <Route path="/build_steps/id/:boardID" component={BuildSteps} />
      <Route path="/build_steps/hash/:boardHash" component={BuildSteps} />

      <Route path="/">
        <Redirect to={`/designer${window.location.search}`} />
      </Route>
    </Switch>
  );
}

export default Routing;
